import {
  SET_INVOICE_FILTER_VALUE,
  EXPAND_INVOICE_FILTER,
  APPLY_INVOICE_FILTERS_SUCCESS,
  RESTORE_INVOICE_FILTERS,
  CLEAR_ALL_INVOICE_FILTERS,
  CLEAR_INVOICE_FILTER,
  SET_INVOICE_FITLER_VALIDATION_ERROR,
  ENABLE_INVOICE_FILTER,
  DISABLE_INVOICE_FILTER,
  RESET_INVOICE_FILTERS
} from './InvoiceFiltersConstants';
import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';
import { INVOICE_FILTERS } from 'shared/constants/SharedConstants';
import {
  INITIAL_FILTERS_STATE,
  FILTERS
} from 'shared/constants/InvoiceFiltersInitialState';

const checkAppliedFilterFlag = filters => {
  let flag = false;
  filters.map(invFilter => {
    if (
      (invFilter.data.type === STRING || invFilter.data.type === DATE) &&
      invFilter.data.value
    ) {
      flag = true;
    }
    if (invFilter.data.type === NUMBER) {
      if (invFilter.data.min.value) {
        flag = true;
      }
      if (invFilter.data.max.value) {
        flag = true;
      }
    }
  });
  return flag;
};

const storedFilters = JSON.parse(sessionStorage.getItem(INVOICE_FILTERS));
const appliedFilters = storedFilters
  ? storedFilters.filters
  : INITIAL_FILTERS_STATE;

const initialState = {
  appliedFilters,
  tempFilters: [...appliedFilters],
  appliedFiltersFlag: checkAppliedFilterFlag(appliedFilters)
};

const InvoiceFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPAND_INVOICE_FILTER:
      return {
        ...state,
        tempFilters: state.tempFilters.map(invFilter => {
          if (invFilter.title === action.filter.title) {
            return { ...invFilter, collapsed: false };
          }
          return { ...invFilter };
        })
      };
    // eslint-disable-next-line no-case-declarations
    case CLEAR_INVOICE_FILTER:
      return {
        ...state,
        tempFilters: action.collapsedFilters
      };
    case RESTORE_INVOICE_FILTERS:
      return { ...state, tempFilters: [...state.appliedFilters] };
    case APPLY_INVOICE_FILTERS_SUCCESS: {
      const invoiceFilters = JSON.parse(
        sessionStorage.getItem(INVOICE_FILTERS)
      );
      invoiceFilters[FILTERS] = state.tempFilters;
      sessionStorage.setItem(INVOICE_FILTERS, JSON.stringify(invoiceFilters));

      return {
        ...state,
        appliedFilters: [...state.tempFilters],
        appliedFiltersFlag: checkAppliedFilterFlag(state.tempFilters)
      };
    }
    case CLEAR_ALL_INVOICE_FILTERS:
      return { ...state, tempFilters: [...INITIAL_FILTERS_STATE] };
    case SET_INVOICE_FILTER_VALUE:
      return {
        ...state,
        tempFilters: state.tempFilters.map(invFilter => {
          if (action.filterType === STRING || action.filterType === DATE) {
            if (invFilter.data.key === action.filterKey) {
              return {
                ...invFilter,
                data: { ...invFilter.data, value: action.value }
              };
            }
          }
          if (action.filterType === NUMBER && invFilter.data.type === NUMBER) {
            if (invFilter.data.min.key === action.filterKey) {
              return {
                ...invFilter,
                data: {
                  ...invFilter.data,
                  min: { ...invFilter.data.min, value: action.value }
                }
              };
            }

            if (invFilter.data.max.key === action.filterKey) {
              return {
                ...invFilter,
                data: {
                  ...invFilter.data,
                  max: { ...invFilter.data.max, value: action.value }
                }
              };
            }
          }
          return { ...invFilter };
        })
      };
    case SET_INVOICE_FITLER_VALIDATION_ERROR:
      return {
        ...state,
        tempFilters: state.tempFilters.map(filter => {
          if (filter.title === action.filterTitle) {
            return { ...filter, filterValidationError: action.validationError };
          } else {
            return filter;
          }
        })
      };
    case ENABLE_INVOICE_FILTER:
      return {
        ...state,
        tempFilters: state.tempFilters.map(filter => {
          if (filter.title === action.filterTitle) {
            return { ...filter, disabled: false };
          } else {
            return filter;
          }
        })
      };
    case DISABLE_INVOICE_FILTER:
      return {
        ...state,
        tempFilters: state.tempFilters.map(filter => {
          if (filter.title === action.filterTitle) {
            return { ...filter, disabled: true };
          } else {
            return filter;
          }
        })
      };
    case RESET_INVOICE_FILTERS:{
      return {
        ...state,
        appliedFilters: INITIAL_FILTERS_STATE,
        tempFilters: INITIAL_FILTERS_STATE,
        appliedFiltersFlag: false
      };
    }
    default:
      return state;
  }
};

export default InvoiceFiltersReducer;



// WEBPACK FOOTER //
// ./src/redux/invoiceFilters/InvoiceFiltersReducer.js